import React from "react";
import "./Topbar.css";

function Topbar() {
  return (
    <div className="top_main_div ">
      <div className="kodenauts">Welcome to Appointilo</div>
    </div>
  );
}

export default Topbar;
